import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { CategoricalChartState } from 'recharts/types/chart/generateCategoricalChart';
import "../App.css";
import { convert2Array, sampleData, downsampleValues } from '../util/util';
import { toast } from "react-toastify";
import { Button, Input, Stack, Text, HStack, Spacer, VStack, FormControl, FormLabel, Switch } from '@chakra-ui/react'

const Graph = () => {
    const [orginData, setOrginData] = useState([Number]);
    const [minValue, setMinValue] = useState(Number(0));
    const [maxValue, setMaxValue] = useState(Number(120));
    const [level, setLevel] = useState(100);
    const [data, setData] = useState(Array.from({ length: 100 }, (_, index) => ({ x: index, y: index + 10 })));
    const [mouseEvent, setMouseEvent] = useState(false);
    const [updateEvent, setUpdateEvent] = useState(false);
    const [IsDataType, setIsDataType] = useState(true);
    const [IsValueFloor, setIsValueFloor] = useState(false);

    const height = 400;
    const chartHeight = height - 10;
    const chartHeightTop = height - 5;

    useEffect(() => {
        //setData(data);        
        setUpdateEvent(false);
    }, [updateEvent])


    const handleMouseDown = () => {
        setMouseEvent(true);
    }
    const handleMouseUp = () => {
        CancelMouse();
    }

    const handleMouseLeave = () => {
        CancelMouse();
    }

    const CancelMouse = () => {
        setMouseEvent(false);
    }

    const handleMouseMove = (e: CategoricalChartState) => {


        if (e == null)
            return;


        if (mouseEvent == false)
            return;

        if (e.activePayload) {
            if (e.chartY && e.activeTooltipIndex) {
                if (e.activeTooltipIndex == 99 || e.activeTooltipIndex == 0) {
                    return;
                }

                const yValue = Math.round(((chartHeightTop - e.chartY) * maxValue) / chartHeight);
                const index = e.activeTooltipIndex;
                const minIndex = index - 20 <= 0 ? 0 : index - 20;

                let IsChange = true;
                if (IsValueFloor) {
                    for (let i = index - 1; i >= minIndex; --i) {
                        const value = data[i];
                        if (yValue < value.y){
                            IsChange = false;
                            break;
                        }
                    }
                }

                data[index] = { x: data[index].x, y: IsChange ? yValue : data[index-1].y};
                // setData(data);                
                setUpdateEvent(!updateEvent);
                //console.log("level : "+ level + ", min : " + minValue + " , max : " + maxValue);
                //console.log(e);
            }
        }
    };

    const onChangeMin = (e: any) => {
        let value: Number = e.target.value;
        setMinValue(Number(value));
    }

    const onChangeMax = (e: any) => {
        let value: Number = e.target.value;
        setMaxValue(Number(value));
    }

    const onChangeLevel = (e: any) => {
        let value: Number = e.target.value;
        setLevel(Number(value));

    }

    const onChangeButton = () => {

        if (level <= 0 || minValue >= maxValue) {
            toast.error("레벨이 0이 또는 \n min값이 max값보다 클 수 없습니다.");
            return;
        }

        let levellength = level;
        if (level > 100)
            levellength = 100;

        let stepValue = maxValue - minValue;
        stepValue = stepValue / (levellength - 1);
        let newdata = Array.from({ length: levellength }, (_, index) => ({ x: index, y: minValue + index * stepValue }));
        setData(newdata);
    }

    const onLoadFile = () => {

    }

    const onReadFile = (evt: any) => {
        const file = evt.target.files[0];

        if (file) {

            const reader = new FileReader();

            reader.onload = (e: any) => {

                const contents = e.target.result;
                const lines = contents.split('\n');
                const datas = lines.map((v: String, index: Number) => {
                    return Number(v.split(',')[1]);
                });

                let level = datas.length <= 100 ? datas.length : 100;
                let covertDatas = datas.length <= 100 ? datas.map((v: number, index: number) => ({ x: index, y: v })) : downsampleValues(datas, level).map((v, index) => ({ x: index, y: v }));

                setMinValue(covertDatas[0].y);
                setMaxValue(covertDatas[covertDatas.length - 1].y);
                setData(covertDatas);
                setLevel(datas.length);
                setUpdateEvent(!updateEvent);
            };

            reader.readAsText(file);
        }
    }

    const onExportButton = () => {

        let downsampledData = data.map((item, index) => item.y);
        const expendArray = convert2Array(sampleData(IsDataType, downsampledData, level));

        const csvContent = expendArray.map(row => row.join(',')).join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        const downloadlink = document.createElement('a');
        downloadlink.href = url;
        downloadlink.download = 'data.csv';
        downloadlink.click();
        window.URL.revokeObjectURL(url);
        toast.success("파일 생성 완료");
    }

    return (
        <div className='no-drag'>
            <Spacer h="50px" />
            <div className='centerDiv'>
                <HStack spacing={3}>
                    <Text as='b' fontSize='lg'>MIN:
                        <Input value={minValue} type="number" onChange={onChangeMin} />
                    </Text>

                    <Text as='b' fontSize='lg'>
                        MAX: <Input value={maxValue} type="number" onChange={onChangeMax} />
                    </Text >

                    <Text as='b' fontSize='lg'>
                        MAX LEVEL: <Input value={level} type="number" onChange={onChangeLevel} />
                    </Text >
                </HStack>
            </div>

            <Spacer h="20px" />
            <div className='centerDiv'>
                <Input className="centerDiv" width="30%" type="file" accept=".csv" onChange={onReadFile} />
            </div>
            <Spacer h="20px" />

            <FormControl className='centerDiv' alignItems='center'>
                <FormLabel htmlFor='int-alerts' mb='0'>Greater than the previous value </FormLabel>
                <Switch id='int-alerts' isChecked={IsValueFloor} onChange={(e) => { setIsValueFloor(!IsValueFloor); }} />
            </FormControl>

            <FormControl className='centerDiv' alignItems='center'>
                <FormLabel htmlFor='int-alerts' mb='0'>int?</FormLabel>
                <Switch id='int-alerts' isChecked={IsDataType} onChange={(e) => { setIsDataType(!IsDataType); }} />
                &nbsp;&nbsp;&nbsp;
                <FormLabel htmlFor='float-alerts' mb='0'>float?</FormLabel>
                <Switch id='float-alerts' isChecked={!IsDataType} onChange={(e) => { setIsDataType(!IsDataType); }} />
            </FormControl>

            <Spacer h="20px" />
            <div className='centerDiv'>
                <HStack spacing={3}>
                    <Button colorScheme='blue' onClick={onChangeButton}>Renew Graph</Button>
                    <Button colorScheme='blue' onClick={onExportButton}>File Export</Button>
                </HStack>

            </div>
            <Spacer h="20px" />
            <div className='centerDiv'>
                <Text as='b' fontSize='2xl'>LEVEL DESIGN</Text>
            </div>
            <Spacer h="20px" />
            <ResponsiveContainer width="90%" height={height} >
                {/* <BarChart data={data} onMouseMove={handleMouseMove} onMouseDown ={handleMouseDown} onMouseUp ={handleMouseUp} onMouseLeave ={handleMouseLeave}> */}
                <LineChart data={data} onMouseMove={handleMouseMove} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp} onMouseLeave={handleMouseLeave}>
                    <CartesianGrid strokeDasharray="3 3" />
                    {/* <XAxis dataKey="x" /> */}
                    <YAxis />
                    {/* <Tooltip isAnimationActive={false} /> */}
                    <Line type="monotone" dataKey="y" stroke="#8884d8" activeDot={{ r: 5 }} dot={false} />
                    {/* <Bar type="monotone" dataKey="y" stroke="#8884d8"   /> */}
                </LineChart>
                {/* </BarChart> */}
            </ResponsiveContainer>
        </div>
    );
};

export default Graph;
